import { componentDefinitions } from "./componentDefinitions";

export const selectComponentDefinitions = (names) => {
    const namesSet = new Set(names);
    return componentDefinitions.filter((definition) => namesSet.has(definition.name));
};
